import BankKEB from '../image/BankKEB.svg';
import BankBOA from '../image/BankBOA.svg';
import BankDGB from '../image/BankDGB.svg';
import BankIBK from '../image/BankIBK.svg';
import BankJPMorgan from '../image/BankJPMorgan.svg';
import BankKB from '../image/BankKB.svg';
import BankKBSecurities from '../image/BankKBSecurities.svg';
import BankKDB from '../image/BankKDB.svg';
import BankNH from '../image/BankNH.svg';
import BankNHInvest from '../image/BankNHInvest.svg';
import BankSC from '../image/BankSC.svg';
import BankSh from '../image/BankSh.svg';
import BankGwangju from '../image/BankGwangju.svg';
import BankDeutsche from '../image/BankDeutsche.svg';
import BankMiraeAsset from '../image/BankMiraeAsset.svg';
import BankBusan from '../image/BankBusan.svg';
import BankForestry from '../image/BankForestry.svg';
import BankSamsungSecurities from '../image/BankSamsungSecurities.svg';
import BankSaemaul from '../image/BankSaemaul.svg';
import BankSuhyup from '../image/BankSuhyup.svg';
import BankShinhan from '../image/BankShinhan.svg';
import BankShinhyup from '../image/BankShinhyup.svg';
import BankCiti from '../image/BankCiti.svg';
import BankWoori from '../image/BankWoori.svg';
import BankPostOffice from '../image/BankPostOffice.svg';
import BankYuanta from '../image/BankYuanta.svg';
import BankSavings from '../image/BankSavings.svg';
import BankJeonbuk from '../image/BankJeonbuk.svg';
import BankJeju from '../image/BankJeju.svg';
import BankKakao from '../image/BankKakao.svg';
import BankKakaoPay from '../image/BankKakaoPay.svg';
import BankK from '../image/BankK.svg';
import BankKiwoom from '../image/BankKiwoom.svg';
import BankToss from '../image/BankToss.svg';
import BankTossSecurities from '../image/BankTossSecurities.svg';
import BankHana from '../image/BankHana.svg';
import BankKoreaInvest from '../image/BankKoreaInvest.svg';
import BankHSBC from '../image/BankHSBC.svg';
import BankDefault from '../image/BankDefault.svg';

// 은행 목록 - 피그마 디자인(10824:54273) 순서대로 //
// code: 금융결제원 표준 3자리 코드 (토스페이먼츠 https://docs.tosspayments.com/codes/org-codes 기준) //
// accountFormats: 자릿수별 하이픈 그룹 패턴 (해당 길이가 없으면 포맷 미적용) //
export const bankList = [
  { code: '081', name: '(구)KEB외환은행', logo: BankKEB, accountFormats: [[3, 6, 3]] },
  { code: '060', name: 'BOA(Bank of America)', logo: BankBOA },
  { code: '031', name: 'DGB대구은행', logo: BankDGB, accountFormats: [[3, 2, 6, 1], [3, 2, 6]] },
  { code: '003', name: 'IBK기업은행', logo: BankIBK, accountFormats: [[3, 6, 2, 3], [3, 6, 5]] },
  { code: '057', name: 'JPMorgan Chase', logo: BankJPMorgan },
  { code: '004', name: 'KB국민은행', logo: BankKB, accountFormats: [[6, 2, 6], [3, 2, 4, 3]] },
  { code: '218', name: 'KB증권', logo: BankKBSecurities },
  { code: '002', name: 'KDB산업은행', logo: BankKDB, accountFormats: [[3, 4, 4, 3], [3, 2, 6]] },
  { code: '011', name: 'NH농협은행', logo: BankNH, accountFormats: [[3, 4, 4, 2], [3, 2, 6]] },
  { code: '247', name: 'NH투자', logo: BankNHInvest },
  { code: '023', name: 'SC제일은행', logo: BankSC, accountFormats: [[3, 2, 6]] },
  { code: '007', name: 'Sh수협은행', logo: BankSh, accountFormats: [[3, 4, 6, 1]] },
  { code: '039', name: '경남은행', logo: BankBusan, accountFormats: [[3, 4, 4, 1], [3, 2, 6, 1]] },
  { code: '034', name: '광주은행', logo: BankGwangju, accountFormats: [[4, 3, 6], [4, 1, 6, 3]] },
  { code: '055', name: '도이치은행', logo: BankDeutsche },
  { code: '238', name: '미래에셋', logo: BankMiraeAsset },
  { code: '032', name: '부산은행', logo: BankBusan, accountFormats: [[3, 4, 4, 2], [3, 2, 7]] },
  { code: '064', name: '산림조합', logo: BankForestry, accountFormats: [[4, 4, 4, 1]] },
  { code: '240', name: '삼성 증권', logo: BankSamsungSecurities },
  { code: '045', name: '새마을금고', logo: BankSaemaul, accountFormats: [[4, 4, 4, 1], [4, 4, 4]] },
  { code: '030', name: '수협중앙회', logo: BankSuhyup, accountFormats: [[3, 4, 6, 1]] },
  { code: '088', name: '신한은행', logo: BankShinhan, accountFormats: [[3, 3, 6], [3, 2, 6]] },
  { code: '048', name: '신협', logo: BankShinhyup, accountFormats: [[4, 4, 4, 1]] },
  { code: '027', name: '씨티은행', logo: BankCiti, accountFormats: [[3, 6, 3]] },
  { code: '071', name: '우체국예금보험', logo: BankPostOffice, accountFormats: [[6, 2, 6]] },
  { code: '020', name: '우리은행', logo: BankWoori, accountFormats: [[4, 3, 6]] },
  { code: '209', name: '유안타증권', logo: BankYuanta },
  { code: '037', name: '전북은행', logo: BankJeonbuk, accountFormats: [[4, 3, 6]] },
  { code: '050', name: '저축은행중앙회', logo: BankSavings, accountFormats: [[4, 4, 4, 1]] },
  { code: '035', name: '제주은행', logo: BankJeju, accountFormats: [[4, 6, 3]] },
  { code: '090', name: '카카오뱅크', logo: BankKakao, accountFormats: [[4, 2, 7]] },
  { code: '288', name: '카카오페이증권', logo: BankKakaoPay },
  { code: '089', name: '케이뱅크', logo: BankK, accountFormats: [[3, 3, 6]] },
  { code: '264', name: '키움증권', logo: BankKiwoom },
  { code: '092', name: '토스뱅크', logo: BankToss, accountFormats: [[4, 4, 4]] },
  { code: '271', name: '토스증권', logo: BankTossSecurities },
  { code: '081', name: '하나은행', logo: BankHana, accountFormats: [[3, 6, 5]] },
  { code: '243', name: '한국투자증권', logo: BankKoreaInvest },
  { code: '054', name: '홍콩상하이은행(HSBC)', logo: BankHSBC }
];

// code → bank 조회용 맵 - code 중복 시 마지막 항목 우선 (081: 하나은행) //
export const bankByCode = bankList.reduce((map, bank) => {
  map[bank.code] = bank;

  return map;
}, {});

// 공백 제거 이름 → bank 조회용 맵 (표준명) //
export const bankByName = bankList.reduce((map, bank) => {
  map[bank.name.replace(/\s+/g, '')] = bank;

  return map;
}, {});

// 백엔드 레거시/축약 표기 별칭 → 표준 code (name 폴백 보강) //
const BANK_NAME_ALIASES = {
  '국민': '004',
  '국민은행': '004'
};

for (const [alias, code] of Object.entries(BANK_NAME_ALIASES)) {
  if (bankByCode[code]) bankByName[alias] = bankByCode[code];
}

// 백엔드 bankCode(2~3자리/누락) + 레거시 bankName 모두 대응해 bank 매칭 //
export function resolveBank(bankCode, bankName) {
  // code 우선 - 숫자만 추출 후 3자리 zero-pad해 매칭 //
  const codeText = bankCode === undefined || bankCode === null ? '' : String(bankCode);

  if (codeText && codeText !== 'None') {
    const padded = codeText.replace(/[^0-9]/g, '').padStart(3, '0');

    if (bankByCode[padded]) return bankByCode[padded];
  }

  // name 폴백 - 공백 제거 후 표준명/별칭 매칭 //
  if (bankName) {
    const normalized = bankName.replace(/\s+/g, '');

    if (bankByName[normalized]) return bankByName[normalized];
  }

  return null;
}

// 은행별 패턴에 맞춰 계좌번호에 하이픈 삽입 - 미등록 은행/길이 불일치 시 원본 숫자 그대로 반환 //
export function formatAccountNumber(bank, accountNumber) {
  if (!accountNumber) return '';

  const digits = String(accountNumber).replace(/[^0-9]/g, '');
  if (!digits) return '';

  const pattern = bank?.accountFormats?.find(p => p.reduce((sum, n) => sum + n, 0) === digits.length);
  if (!pattern) return digits;

  const parts = [];
  let cursor = 0;

  for (const length of pattern) {
    parts.push(digits.slice(cursor, cursor + length));
    cursor += length;
  }

  return parts.join('-');
}
